var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('LpButton',{attrs:{"ghost":""},on:{"click":function($event){return _setup.requestError()}}},[_vm._v("\n        Throw XHR error\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }